import React from "react";
import Report from "./Report";
import help from "help/viewThroughputProtocols.md";
import View from "common/View";

const ProtocolsThroughput = () => (
  <View
    title="Throughput by protocols"
    mdHelp={help}
  >
    <Report />
  </View>
);

export default ProtocolsThroughput;
